import { Injectable } from '@angular/core';
import { Auth, onAuthStateChanged } from '@angular/fire/auth';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class AuthCheckService {
  constructor(
    private auth: Auth,
    private router: Router,
  ) {}

  async requireLogin(): Promise<boolean> {
    const user = this.auth.currentUser;
    if (user) return true;

    // Navigate to Login Page with Return URL
    this.router.navigate(['/login'], {
      queryParams: { returnUrl: this.router.url },
    });

    return false;
    // We return false because the current action is effectively cancelled/interrupted by navigation.
    // The user will have to retry the action after landing back on the page.
    // Alternatively, we could await the auth state change here, but since we are navigating away,
    // the calling component is likely destroyed or the context is lost.
  }
}
